import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useSelector, shallowEqual } from "react-redux";

const DELIVERY_URL = "api/batches/delivery-type";
const COURSE_URL = "api/customer-leads/course/";
const getCoursesUrl = `api/portal-programs/`;
const getBatchesUrl = `api/programs/`;

const CustomerLeadsContext = createContext();

export function useCustomerLeadsContext() {
  return useContext(CustomerLeadsContext);
}

export const CustomerLeadsConsumer = CustomerLeadsContext.Consumer;

export function CustomerLeadsContextProvider({
  leadUICustomerLeads,
  children,
}) {
  const [DELIVERYTYPE, SETDELIVERYTYPE] = useState([]);
  const [COURSE, SETCOURSE] = useState([]);
  const [AUTOSELECTCOURSE, SETAUTOSELECTCOURSE] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedTrialDate, setSelectedTrialDate] = useState(null);
  const [selectedCourseData, setSelectedCourseData] = useState();

  const branch = useSelector(
    (state) => state.auth.branches.currentBranch,
    shallowEqual
  );
  // BasePage renders this provider as soon as a persisted authToken exists,
  // but the axios "x-auth-token" default header isn't attached until
  // getUserByToken() (authCrud.js) resolves and state.auth.user is set. On a
  // fresh load landing directly on /customer-leads, this effect's child
  // component mounts (and fires) before BasePage's own auth-bootstrap effect
  // — so without this gate, these requests go out with no token and 401.
  const isAuthReady = useSelector((state) => !!state.auth.user, shallowEqual);
  // const [refetch, setRefetch] = useState(false);

  useEffect(() => {
    if (!isAuthReady) return;

    const INIT_HELPERS = async () => {
      try {
        let res_delivery_type = await axios(DELIVERY_URL);
        // console.log("Got dt ", res_delivery_type.data.result)
        SETDELIVERYTYPE(res_delivery_type.data.results);
        let res_course = await axios(COURSE_URL + branch.branch_id);
        // console.log("context 1 programs: ", res_course.data.results);
        let sortedData = res_course.data.results.map((c) => {return {label: c.abbr, value: c.id, category: c.category, name: c.name, code: c.code}})
        SETCOURSE(sortedData);

        const result_course_data = await axios(getCoursesUrl, {
          params: { branch_id: branch.branch_id, type: "programs" },
        });
        SETAUTOSELECTCOURSE(result_course_data.data.results)
      } catch (e) {
        console.error(e);
      }
    };

    INIT_HELPERS();
  }, [branch, isAuthReady]);

  const getCourseBatches = useCallback(async () => {
    if (selectedCourse && selectedTrialDate) {
      const result = await axios(
        getCoursesUrl +
          `batches/` +
          selectedCourse.id +
          `?branchId=${branch.branch_id}` +
          `&trialDate=${selectedTrialDate}`
      );
  
      setSelectedCourseData(result.data.results);
      }
  }, [selectedCourse, selectedTrialDate, branch, getCoursesUrl]);

  useEffect(() => {
    getCourseBatches();
  }, [getCourseBatches]);

  // const setRefetchHandler = (value) => {
  //   setRefetch(value);
  // };

  // const getRefetch = () => {
  //   return refetch;
  // };

  const LeadsContext = {
    newCustomerLeadsButtonClick:
      leadUICustomerLeads.newCustomerLeadsButtonClick,
    openEditCustomerLeadsPage: leadUICustomerLeads.openEditCustomerLeadsPage,
    openDeleteCustomerLeadsDialog:
      leadUICustomerLeads.openDeleteCustomerLeadsDialog,
    openDuplicateCustomerLeadsPage:
      leadUICustomerLeads.openDuplicateCustomerLeadsPage,
      openEmailPage: leadUICustomerLeads.openEmailPage,
    refetch: leadUICustomerLeads.refetch,
    setRefetch: leadUICustomerLeads.setRefetch,
    TYPES: {
      DELIVERYTYPE,
      SETDELIVERYTYPE,
      COURSE,
      SETCOURSE,
      AUTOSELECTCOURSE,
      SETAUTOSELECTCOURSE,
      selectedCourse: selectedCourse,
      setSelectedCourse: setSelectedCourse,
      selectedCourseData: selectedCourseData,
      setSelectedCourseData: setSelectedCourseData,
      selectedTrialDate: selectedTrialDate,
      setSelectedTrialDate: setSelectedTrialDate,
    },
  };

  return (
    <CustomerLeadsContext.Provider value={LeadsContext}>
      {children}
    </CustomerLeadsContext.Provider>
  );
}
